import { DataService } from 'src/app/services/data.service';
import { BreadCrumb } from './../../../../interfaces/main';
import { ActivatedRoute } from '@angular/router';
import { View } from './../../../../interfaces/enums';
import { FormControl, Validators } from '@angular/forms';
import { Lesson } from './../../../../interfaces/course';
import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';

@Component({
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {

  lessons: Lesson[];

  View = View;

  showData: Lesson[];
  currentPage = 1;
  totalItemsPerPage = 6;

  viewState: View = View.Grid;

  breadcrumbs: BreadCrumb[] = [{
    link: 'Home',
    url: ['/']
  },{
    link: 'Courses'
  }]

  searchForm = new FormControl('');

  constructor(
    private data: DataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getCourses();

    this.searchForm.valueChanges.subscribe(async (v) => {
      if(!v){
        return;
      }

      const lessons = _.filter(this.lessons, (i) => {
        const regex = new RegExp(v, 'gi');

        return i.course && i.course.topic && String.prototype.search.call(i.course.topic, regex) !== -1;
      })

      this.showData = lessons;
    })
  }

  getCourses(){
    this.data.getLessons().subscribe((res) => {
      if(res && res.data){
        this.lessons = res.data;
        this.showData = this.lessons;

        this.filter();
      }
    })
  }

  filter(){
    if(this.route.snapshot.queryParams){
      const {queryParams: params} = this.route.snapshot;

      let data = this.lessons;

      if(params.l){
        data = _.filter(data, (v) => _.lowerCase(v.course.language) === _.lowerCase(params.l));
      }

      if(params.c){
        data = _.filter(data, (v) => _.lowerCase(v.course.category) === _.lowerCase(params.c));
      }

      if(params.s){
        data = _.filter(data, (v) => v.course.max_students >= parseInt(_.first(_.split(params.s, '-'))) && v.course.max_students <= parseInt(_.last(_.split(params.s, '-'))));
      }

      this.showData = data;
    }
  }
}
